
import {React, useState, useContext, useEffect, useRef} from "react"
import{UserContext} from '../../context/userContext/userContext';
import { useStyle } from '../../context/styleContext/styleContext';
import ReactGA from 'react-ga4';
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  useMediaQuery,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';



export default function Support(){

  const { user } = useContext(UserContext);
  const { isLoading } = useContext(UserContext);
  const { style, setStyle } = useStyle();

  const [height, setHeight] = useState(window.innerHeight)
  const [width, setWidth] = useState(window.setWidth)

  useEffect(() => {
    function handleResize() {      
      setWidth(window.innerWidth)
      setHeight(window.innerHeight)
  }
  
    window.addEventListener('resize', handleResize)
  })

  const isMobile = useMediaQuery("(max-width:600px)");
  const topContainer = useRef();
    useEffect(() => {
        // To make sure page starts from the top
        topContainer.current.scrollIntoView({ block: "end" });
    }, []);

    ReactGA.send({
      hitType:"pageview",
      page:"support",
      title:"support",
    })

    useEffect(() => {
      document.title = 'Parish Audio | Cutting-Edge Audio Processing | Support';
  }, []);


  const changeBackground = () => {
    setStyle({ ...style, backgroundColor: 'rgb(0,255,0)' });
  };

    return(
        <>

<div style={{width:'95%', margin:'auto', minHeight:height-160}}>
    <Box
      sx={{
        maxWidth: "900px",
        margin: "auto",
        pl: isMobile ? 2 : 4,
        pr: isMobile ? 2 : 4,
        pt: isMobile ? 1 : 2,
        pb: isMobile ? 2 : 4,
        mt: 4,
        mb: 4,
        backgroundColor: style.color1,
        borderRadius: 2,
        color: style.color4,
        marginBottom:'25px'
      }}
    >
      <h1 ref={topContainer} className='h1-A' style={{marginTop:'0px', marginBottom:'20px', fontSize:'1.5em'}}>
        Support
      </h1>


      <Accordion
        
        sx={{
          boxShadow:10,
          backgroundColor: style.color1,
          color: style.color1,
          mb: 2,
          borderRadius: 1,
          "&:before": { display: "none" },
        }}
        >
        <AccordionSummary
          expandIcon={<ExpandMore sx={{ color: style.color2 }} />}
          sx={{
            fontSize: "1.2rem",
            fontWeight: "bold",
            backgroundColor: style.color1,
            filter:'brightness(1.2)',
            color:style.color4,
            borderRadius: 1,
            "& .MuiAccordionSummary-content": {
              margin: 0,
            },
          }}
        >
            How do I install my plugin?
          </AccordionSummary>
          <AccordionDetails
            sx={{ backgroundColor: style.color1, filter:'brightness(1.35)',fontSize: "1.1rem", color:style.color4, textAlign:'center' }}
          >
            <strong style={{fontSize:'1.15rem', filter:'brightness(0.75)', textAlign:'center', margin:'auto', width:'100%'}}>We recommend closing your DAW or host program prior to installation.</strong>

            <ul className='a' style={{fontSize: "1.1rem", filter:'brightness(0.75)', marginTop:'25px', textAlign:'left', marginLeft:'10px'}}>

              <li style={{marginBottom:'20px'}}>
                <strong>Step 1:</strong> Download the app installer from the <a href="/my-gear"><strong>My Gear</strong></a> page. 
              </li>
              <li style={{marginBottom:'20px'}}>
                <strong>Step 2:</strong> Run the app installer. This will install your plugin to the correct location so it can be recognized automatically by your DAW. 
              </li>
              <li style={{marginBottom:'20px'}}>
                <strong>Step 3:</strong> When you open the plugin for the first time, enter your email and password to unlock it.
              </li>
              <li style={{marginBottom:'20px'}}>
                <strong>Step 4:</strong> Enjoy!
              </li>
            </ul>

          </AccordionDetails>
        </Accordion>


        <Accordion
        
        sx={{
          boxShadow:10,
          backgroundColor: style.color1,
          color: style.color1,
          mb: 2,
          borderRadius: 1,
          "&:before": { display: "none" },
        }}
        >
        <AccordionSummary
          expandIcon={<ExpandMore sx={{ color: style.color2 }} />}
          sx={{
            fontSize: "1.2rem",
            fontWeight: "bold",
            backgroundColor: style.color1,
            filter:'brightness(1.2)',
            color:style.color4,
            borderRadius: 1,
            "& .MuiAccordionSummary-content": {
              margin: 0,
            },
          }}
        >
            Where are my VST3 files located on my device?
          </AccordionSummary>
          <AccordionDetails
            sx={{ backgroundColor: style.color1, filter:'brightness(1.35)',fontSize: "1.0rem", color:style.color4, textAlign:'left' }}
          >
                    On Windows devices, your VST3 plugins are installed to the following folder:
                    <br />
                    
                     <strong>C:\Program Files\Common Files\VST3</strong>
                     <br />
                     <br />

                      On Mac computers, your VST3 plugins are installed to the following folder:
                      <br />

                      <strong>/Library/Audio/Plug-Ins/VST3</strong>    

          </AccordionDetails>
        </Accordion>


        <Accordion
        
        sx={{
          boxShadow:10,
          backgroundColor: style.color1,
          color: style.color1,
          mb: 2,
          borderRadius: 1,
          "&:before": { display: "none" },
        }}
        >
        <AccordionSummary
          expandIcon={<ExpandMore sx={{ color: style.color2 }} />}
          sx={{
            fontSize: "1.2rem",
            fontWeight: "bold",
            backgroundColor: style.color1,
            filter:'brightness(1.2)',
            color:style.color4,
            borderRadius: 1,
            "& .MuiAccordionSummary-content": {
              margin: 0,
            },
          }}
        >
            Contact Us
          </AccordionSummary>
          <AccordionDetails
            sx={{ backgroundColor: style.color1, filter:'brightness(1.35)',fontSize: "1.1rem", color:style.color4, textAlign:'left' }}
          >
              We would love to hear from you. If you have questions or need assistance, please contact us at <a href="mailto:support@parishaudio.com" style={{color:style.color2, fontSize:'14pt'}}><strong>support@parishaudio.com</strong></a>.
          </AccordionDetails>
        </Accordion>

    </Box>
    </div>





        {/* <div ref={topContainer} style={{display:'flex', flexDirection:'column', width:'100%', backgroundImage: `url("/RecordingStudioStockImage1.jpg")`, backgroundSize: "cover", backgroundPosition: "center"}}>
          <div style={{textAlign:'left', color: style.color4, minHeight:height - 130, backgroundColor:'rgba(0,0,0,.7)'}}>
            

            <div style={{width:'95%', maxWidth:'1000px', margin:'auto', marginBottom:'50px'}}>
            <div>
            <h1 style={{marginTop:'25px', marginBottom:'25px'}}> Support</h1>
            </div>
            <div>
            <Accordion sx={{backgroundColor:style.color4, color:style.color5}}>
                <AccordionSummary
                  expandIcon={<ArrowDownwardIcon style={{color:style.color5}}/>}
                  aria-controls="panel2-content"
                  id="panel2-header"
                >
                  <Typography sx={{marginTop:'0px', marginBottom:'0px'}}><h2 style={{marginTop:'0px', marginBottom:'0px'}}>Installing your Plugins</h2></Typography>
                </AccordionSummary>
                <AccordionDetails sx={{backgroundColor:style.color4, color:style.color5, textAlign:'left'}}>
                  <Typography>
                   To install your plugin, first click the download link for your operating system (Windows or Mac), which will download an installer program. Next, it is recommended that you close your DAW or any other program that uses VST3 files prior to installation. Once they have been closed, run the installer program that was downloaded, which will setup and configure all of the necessary files and place everything in the proper location.
                   <br />
                   <br />
                   Once the installer is finished, you will be able to use the VST3 plugin in your DAW. If the plugin does not appear automatically, rescan your plugin directories from within your DAW, or follow your DAW specific instructions for VST3 installation.
                   <br />
                   <br />
                  If you need assistance, please contact us at <a href="mailto:support@parishaudio.com" style={{color:style.color2, fontSize:'14pt'}}><strong>support@parishaudio.com</strong></a>. 
                  </Typography>
                </AccordionDetails>
              </Accordion>



              <Accordion sx={{backgroundColor:style.color4, color:style.color5}}>
                <AccordionSummary
                  expandIcon={<ArrowDownwardIcon style={{color:style.color5}}/>}
                  aria-controls="panel2-content"
                  id="panel2-header"
                >
                  <Typography sx={{marginTop:'0px', marginBottom:'0px'}}><h2 style={{marginTop:'0px', marginBottom:'0px'}}>VST3 file location</h2></Typography>
                </AccordionSummary>
                <AccordionDetails sx={{backgroundColor:style.color4, color:style.color5, textAlign:'left'}}>
                  <Typography>
                    On Windows computers, your VST3 plugins are installed to the following folder:
                    <br />
                    
                     <strong>C:\Program Files\Common Files\VST3. </strong>
                     <br />
                     <br />

                      On Mac computers, your VST3 plugins are installed to the following folder:
                      <br />

                      <strong>/Library/Audio/Plug-Ins/VST3       </strong>               

                     
                  </Typography>
                </AccordionDetails>
              </Accordion>


              <Accordion sx={{backgroundColor:style.color4, color:style.color5}}>
                <AccordionSummary
                  expandIcon={<ArrowDownwardIcon style={{color:style.color5}}/>}
                  aria-controls="panel2-content"
                  id="panel2-header"
                >
                  <Typography style={{marginTop:'0px', marginBottom:'0px'}}><h2 style={{marginTop:'0px', marginBottom:'0px'}}>Contact Us</h2></Typography>
                </AccordionSummary>
                <AccordionDetails sx={{backgroundColor:style.color4, color:style.color5}}>
                  <Typography>
                  We would love to hear from you. If you have questions or need support, please contact us at <a href="mailto:support@parishaudio.com" style={{color:style.color2, fontSize:'14pt'}}><strong>support@parishaudio.com</strong></a>.
                  </Typography>
                </AccordionDetails>
              </Accordion>
              </div>
            </div>

                
            </div>
          </div> */}
        </>

    )
}